// import logo from './logo.svg';
// import './App.css';
import React, {useEffect, useState, useRef} from 'react';
import PageInfoStore from './flux/PageInfoStore';
import MainSubNavChild from './MainSubNavChild';

export default function MainSubNav(props) {
  const category = props.category;
  const menuSpan = useRef();
  const [animate, setAnimate] = useState(false);
  const theTitle = category.title.replaceAll('&amp;', '&');

  useEffect(() => {
    PageInfoStore.setMenuHeights(category.handle, menuSpan.current.clientHeight);
    setTimeout(() => {
      if(!animate) {
        setAnimate(true);
      }
    }, 10);
  });

  function renderTitle() {
    switch(theTitle) {
      case 'Parts':
        return ( <h3><a href={category.url}>{theTitle}</a></h3> );
      default:
        return ( <h3><a href={category.url}>{theTitle}</a></h3> );
        // return (<h3>{theTitle}</h3>);
    }
  }

  return (
      <span className="menu-container sub-nav-container" ref={menuSpan}>
        <div className="page-width">
          <div className={animate ? 'menu' : 'menu animate'}>
            { renderTitle() }
            <ul>
              {category.children.map((subCat) => {
                return (
                  <MainSubNavChild
                    parentHandle={category.handle} 
                    subCat={subCat}
                    key={subCat.handle}
                  />
                )
              })}
            </ul>
          </div>
        </div>
      </span>
  );
}